import { useQuery } from "@tanstack/react-query"
import { api } from "../documentation"

export const GET_OBJECTS_KEY = "get_objects"

export const useGetObjects = (livingComplexId?: number, name?: string) => {
    return useQuery({
        queryKey: [GET_OBJECTS_KEY, ...[livingComplexId, name].filter(v => v)],
        queryFn: () => api.GetObjects(livingComplexId!, name),
        enabled: !!livingComplexId
    });
}